import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { observe } from "mobx";
import { observer, Provider } from "mobx-react";

import Loader from "./Loader";
import SunsetModal from "./SunsetModal";

@observer
export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      sunsetActive: true
    };

    observe(props.store, "isInitialized", change => {
      if (change.newValue && !change.oldValue) {
        if (!props.store.isAuthenticated) {
          this.loadGuestRoutes();
        }
      }
    });

    observe(props.store, "isAuthenticated", change => {
      if (change.newValue && !change.oldValue) {
        this.loadUserRoutes();
      }

      if (!change.newValue && change.oldValue) {
        this.setState({ sunsetActive: true });
        this.loadGuestRoutes();
      }
    });
  }
  
  closeModal = name => {
    this.setState({ [name + "Active"]: false });
  };

  loadGuestRoutes() {
    this.setState({ isLoading: true });
    import("./GuestRoutes").then(module => {
      this.GuestRoutes = module.default;

      this.setState({ isLoading: false });
    });
  }

  loadUserRoutes() {
    this.setState({ isLoading: true });
    import("./UserRoutes").then(module => {
      this.UserRoutes = module.default;

      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 0);
    });
  }

  renderRoutes() {
    const { store } = this.props;
    if (store.isAuthenticated) {
      const { UserRoutes } = this;
      return UserRoutes && <UserRoutes />;
    } else {
      const { GuestRoutes } = this;
      return GuestRoutes && <GuestRoutes />;
    }
  }

  render() {
    const { store } = this.props;
    const { isLoading, sunsetActive } = this.state;

    return (
      <Provider store={store}>
        <Router>
          <div>
            {store.isInitialized && !isLoading && this.renderRoutes()}

            <Loader isVisible={!store.isInitialized || isLoading} />

            <SunsetModal
              onRequestClose={() => this.closeModal("sunset")}
              isOpen={sunsetActive && store.isAuthenticated}
            />
          </div>
        </Router>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js